import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ProductsComponent } from './pages/products/products.component';
import { ProductDetailComponent } from './pages/product-detail/product-detail.component';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    title: 'Alves Faróis & Auto Peças - Início'
  },
  {
    path: 'produtos',
    component: ProductsComponent,
    title: 'Produtos - Alves Faróis & Auto Peças'
  },
  {
    path: 'produtos/:codigo',
    component: ProductDetailComponent,
    title: 'Detalhes do Produto - Alves Faróis & Auto Peças'
  },
  {
    path: 'categoria/:slug',
    component: ProductsComponent,
    title: 'Categoria - Alves Faróis & Auto Peças'
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];
